module.exports = __webpack_public_path__ + "img/refinance.b48f9514.svg";